// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExpenseInfoDto
 */
export interface IExpenseInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IExpenseInfoDto
     */
    claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IExpenseInfoDto
     */
    provider_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IExpenseInfoDto
     */
    provider_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IExpenseInfoDto
     */
    requested_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IExpenseInfoDto
     */
    paid_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IExpenseInfoDto
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof IExpenseInfoDto
     */
    status_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IExpenseInfoDto
     */
    category_type?: IExpenseInfoDtoCategoryTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IExpenseInfoDto
     */
    marked_as_action_required?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IExpenseInfoDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the IExpenseInfoDto interface.
 */
export function instanceOfIExpenseInfoDto(value: object): value is IExpenseInfoDto {
    return true;
}

export function IExpenseInfoDtoFromJSON(json: any): IExpenseInfoDto {
    return IExpenseInfoDtoFromJSONTyped(json, false);
}

export function IExpenseInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpenseInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'provider_name': json['provider_name'] == null ? undefined : json['provider_name'],
        'requested_amount': json['requested_amount'] == null ? undefined : json['requested_amount'],
        'paid_amount': json['paid_amount'] == null ? undefined : json['paid_amount'],
        'status': json['status'] == null ? undefined : json['status'],
        'status_date': json['status_date'] == null ? undefined : (new Date(json['status_date'])),
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'marked_as_action_required': json['marked_as_action_required'] == null ? undefined : json['marked_as_action_required'],
    };
}

export function IExpenseInfoDtoToJSON(json: any): IExpenseInfoDto {
    return IExpenseInfoDtoToJSONTyped(json, false);
}

export function IExpenseInfoDtoToJSONTyped(value?: IExpenseInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_id': value['claim_id'],
        'provider_id': value['provider_id'],
        'provider_name': value['provider_name'],
        'requested_amount': value['requested_amount'],
        'paid_amount': value['paid_amount'],
        'status': value['status'],
        'status_date': value['status_date'] == null ? undefined : ((value['status_date']).toISOString()),
        'category_type': value['category_type'],
        'marked_as_action_required': value['marked_as_action_required'],
    };
}

